export const PRIVACY_POLICY = {
  blocks: [
    {
      key: '245ru',
      text: '1. PREAMBLE',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 11, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '8gvsm',
      text: `Jio Payment Solutions Limited (formerly known as Reliance Payment Solutions Limited) (“JPSL”) is committed to protecting your privacy. This Privacy Policy describes how JPSL collects, use, share and safeguard your Personal Information received from you. 
      This Privacy Policy shall be construed in accordance with the provisions of Indian laws and regulations including the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 under the Information Technology Act, 2000 for collection, use, storage, transfer, disclosure of Personal Information (as defined below).`,
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 86, length: 8, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    { key: '4oel3', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '95m4b',
      text: '2. CONSENT',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 10, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'dt383',
      text: `We process your Personal Information with consent. By using any of the JPSL services and/or using/downloading/accessing JPSL app, JPSL website, applications, platforms, JPSL’s service providers platform (“Platform”) you consent to the processing of your Personal Information by the JPSL in accordance with this Privacy Policy. Your products’ terms and conditions will cover specific matters in addition to this Privacy Policy and this Privacy Policy does not limit any of those specific matters or any other consent that you may have given or may give to or for the benefit of the JPSL. Therefore, please also read such specific terms and conditions in relation to the products and such other consents, wherever applicable.  JPSL reserves the right to amend this Privacy Policy from time to time and shall publish such amendments on the Platform. Please review the policy from time to time periodically to keep yourself updated and aware about any changes/amendments to the Privacy Policy.   If you do not agree with this Privacy Policy, please do not access/use/download any of the JPSL services and/or using/downloading/accessing JPSL app, JPSL website, applications, platforms, JPSL’s service providers platform. `,
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 203, length: 12, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    { key: '3scuu', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '60atq',
      text: '3. APPLICABILITY',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 16, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '2bssh',
      text: 'This policy is applicable to Personal Information collected by JPSL directly from you and /or JPSL’s holding/ultimate holding and/or subsidiary companies and/or group companies and/or its affiliates and/or partners and/or third party service providers (“affiliates”) and/or Platform. Also JPSL receives such Personal Information from various sources which is including but not limited to customer application forms, transactions made by customer using JPSL services, transactions with third parties, online service, contests, promotions, schemes, employers, customer reviews, complaints etc.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 252, length: 14, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    { key: '95tf2', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '7kl41',
      text: '4. PERSONAL INFORMATION',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 23, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '9g6vl',
      text: 'During course of your association with JPSL, JPSL will collect and store your Personal Information. Personal Information shall mean information that could reasonably be used to identify you personally. This includes, but not limited to the following (“Personal Information”):',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 250, length: 24, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '3os83',
      text: 'Information which you may provide during the registration process such as Name, Phone Number, Email Address, Communication or Permanent Address, date of birth, identification number, mobile number, occupation, assets and income, account balances, payment history, account activity, creditworthiness.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '2l0e',
      text: 'Photograph and/or any other personal document provided during registration or during the profile update such as proof of identity, proof of address, information about mobile phone, electricity connection, television/direct to home service and any other information which you provider for availing services from the JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8gict',
      text: 'Usage logs and/or Transactions performed and related information which can identify you as an individual through your customer ID or other relevant unique identifier.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'k4qk',
      text: 'IP Addresses.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6aqqe',
      text: 'Access Information about your actual location using third party services which may include accessing your location, IP address, GPS location etc.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5kuln',
      text: 'Media Access Control address.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'de0gt',
      text: 'Device specific information or identifiers such as IMEI, OS specific identifiers.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'o4ib',
      text: 'Usage logs/ Server logs/ Cookies having Personal Information and Sensitive Personal Information.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8vq3o',
      text: 'Any other Sensitive Personal Information, such as -',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9jec5',
      text: 'Passwords.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'erf04',
      text: 'Financial information, such as details of JPSL account, card holder name, card expiration date, cvv number, credit card, debit card, or other payment instrument details, financial transactions etc.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bf1f1',
      text: 'Medical records and history.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9bd9v',
      text: 'Biometric information.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '2pg1k',
      text: 'This information can be in electronic or physical format.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bntol',
      text: 'Any comments, messages, feedback, complaints blogs, scribbles etc. posted /uploaded /conveyed /communicated by you on the public sections of the application becomes published content and is not considered Personal Information and/or Sensitive Personal Information. Any Sensitive Personal Information i.e. freely available or accessible in public domain or furnish under the right to information act or any other law shall not be treated as Sensitive Personal Information.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'dei8d', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'bpemn',
      text: '5. USE OF PERSONAL INFORMATION',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 30, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '3rt0b',
      text: 'JPSL may collect, use, store and transfer your Personal Information including Sensitive Personal Information for the following purposes:',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8h0ct',
      text: 'Verification of your identity, access and any other services you may avail from JPSL including consent to link or access payment services of other financial institutions.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3u15g',
      text: 'Provisioning of products/services, testing or improvement of services, recommending various products or services of the JPSL to you, including that of affiliates of JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6t9mr',
      text: 'Processing your requests, transactions, enquiries and complaints, customer services and related activities.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6aa89',
      text: 'For provision, operation, processing or administration of any of the services provided to you including responding to your complaints/requests.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bqn5u',
      text: 'Communicating to you about bills, invoices, existing or new offers, content, advertisements, surveys, key policies or other administrative information of the JPSL',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'edphq',
      text: 'For data processing, statistical or risk analysis and for analytics and review for improvement of the product/services.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'fs3s7',
      text: 'Improving your experience while using the application by presenting advertising, products and offers tailored to you.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3nf1n',
      text: 'For designing and marketing, JPSL products/services and its affiliates products/services.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'elf1k',
      text: 'To enable the proposed assignee/transferee of the JPSL to evaluate the assignment/transfer.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8vjja',
      text: 'To manage JPSL’s business and offer good experience on Platform and third party websites/mobile apps.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4jcuo',
      text: 'For any incidental and associated purposes relating to the JPSL services.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3gk9d',
      text: 'For checking your interest in JPSL’s services.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5ovjm',
      text: 'To protect the JPSL from any fraud, error, criminal activity etc.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b3a69',
      text: 'Ensuring adherence to legal and regulatory requirements including but not limited to for prevention and detection of frauds and crimes etc.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8qgq6',
      text: ' For collection of debit and assisting any other financial institutions in relation thereto.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ekn0v',
      text: 'For conducting risk management.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1lg68',
      text: 'For sharing with clearing houses, payment intermediaries, payment mechanism.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4an2p',
      text: 'JPSL may share Personal Information with its affiliates for providing JPSL services effectively and/or for offering various affiliate products to you.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'fc7n', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '5ovi4',
      text: '6. DISCLOSURE',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 13, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '3kuil',
      text: 'JPSL shall not use or disclose Information for purposes other than as mentioned in this policy, except with the consent of customer providing such Information or as required by law.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ai8qc',
      text: 'In a scenario where JPSL or JPSL’s assets are merged or acquired by the other business entities, or during restructuring of business or re-organization, JPSL may share Personal Information provided by you to such business entities. If any such an event occurs the other business entity or the newly combined business entity will ensure safeguarding of your Personal Information.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '7if7',
      text: 'JPSL engages a number of vendors, consultants, contractors and take support from its affiliates for providing services to you. JPSL may provide limited access of your information to such partners to enable them to provide the services subscribed by you.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ujqv',
      text: 'JPSL’s affiliates and their employees operate under a contract and strict security & confidentiality restrictions. JPSL take adequate measures to ensure that JPSL’s affiliates adopt appropriate level of security practices and procedures to ensure security of your Personal Information.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9kv49',
      text: ' JPSL may share your Personal Information with government/government authorities or agencies/ legal / regulatory authorities/courts a) as and when demanded by these authorities b) as per/ to comply with applicable laws/applicable regulations c) to comply with legal process/court orders/judgements/notices etc. d) to enforce applicable terms and conditions accepted by you for availing services including this Privacy Policy e) to protect JPSL, JPSL’s customers and affiliates rights, privacy, safety or property.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'fijh',
      text: 'The Personal Information, provided by you, may be shared with JPSL’s affiliates to help to detect and prevent identity theft, frauds and other illegal activities; correlate or map related accounts to prevent misuse of JPSL Services and to provide you service.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '46egf', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'fi9d0',
      text: '7. INFORMATION SECURITY AND STORAGE',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 35, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    { key: '6k0ba', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '407ol',
      text: 'JPSL shall retain Information for only as long as necessary to meet legal or regulatory requirements or for legitimate business purposes as mentioned in this policy.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '407ok',
      text: 'JPSL has implemented required security practices and standards, in line with the global standards and have a comprehensive documented information security program and policy in place, which contains managerial, technical, operational and physical security control measures that commensurate with the information assets being protected with JPSL’s nature of business. It is being reviewed periodically to keep pace with business, technology and regulatory changes.  Additionally, JPSL has adopted measures to ensure that your Personal Information is accessible to JPSL employees or affiliate’s employees strictly on the ‘need to know’ basis.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'rq0q',
      text: 'JPSL applications/website has industry standard security precautions in place to protect the loss, misuse and alteration of your Personal Information with JPSL. Whenever you change or access your account information, JPSL will facilitate the use of a secure server. JPSL apply appropriate security controls to protect your Personal Information when stored or transmitted by JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1i4nu',
      text: 'JPSL has taken appropriate steps for the security and protection of all our digital platforms including internal applications, however, JPSL shall not be responsible for any breach of security or the disclosure of Personal Information by the customers and/or merchant itself or for reasons outside JPSLs control.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6jkdm',
      text: 'JPSL may share personal information with third-parties such as legally recognized authorities, regulatory bodies, governmental authorities, and financial institutions for the Purpose set out in this Policy or as per applicable laws. JPSL do not accept any responsibility or liability for usage of your Personal Information by these third parties or their policies.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '7una',
      text: 'JPSLs shall not be responsible for the disclosure of Personal Information and Sensitive Personal information if it is available in public domain.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '783kl', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '7am8v',
      text: '8. THIRD PARTY WEBSITES, APPLICATIONS AND SERVICES',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 50, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '859p4',
      text: 'The JPSLs Platform, application/websites/mobile app or any online platform may include links to other websites/applications. Such websites/ application are governed by third party operator’s privacy policies, which are beyond JPSLs control and JPSL will not be responsible for their privacy practices or the content.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '363iv', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'dfjsb',
      text: '9. ACCESS, CORRECTION OF INFORMATION AND WITHDRAWAL OF CONSENT',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 62, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ba0k4',
      text: 'Any modifications / corrections required to the information can be carried out by contacting grievance officer. If the customer wants to withdraw his / her consent to provide Sensitive Personal Information, he / she may contact the grievance officer, the details whereof are provided in clause 10 of this policy.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'camqp', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '9c34v',
      text: '10. QUERIES AND COMPLAINTS',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 26, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'csvjh',
      text: 'For any queries, concerns, complaints or feedback regarding the processing of your Personal Information or on the policy, please feel free to reach JPSL at the below mentioned details:',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '8h8pf', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '8qmo',
      text: 'Name:',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 5, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '8qm1',
      text: 'Contact Details:',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 16, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '25atd',
      text: 'Email ID: care@jiopay.in',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 25, style: 'BOLD' }],
      entityRanges: [{ offset: 10, length: 15, key: 0 }],
      data: {},
    },
    { key: '8h8pf', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '3r44e',
      text: 'This Policy should be read in conjunction with Terms & Conditions/agreement applicable for availing JPSLs services accepted by you.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:care@jiopay.in' } },
  },
}
